import stateCopyJson from '../content/stateCopy.json';

export const useStateCopy = () => {
  const data = stateCopyJson.data;
  const error = null;

  return {
    data,
    error,
    loading: false,
  };
};
